export const environment = {
  production: true,
  buildId: '2735775984918721',
  configFile: 'config.json',
};
